
import Dictionary from "./Dictionary"
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <h1>Dictionary App</h1>
      <main>
        <Dictionary />
      </main>
    </div>
  );
}

export default App;
